// TransferredProduct State

export default {
  transferList: [],
  transferProductsList: [],
  transferOutletsList: [],
  transferInfo: {},
  pendingTransferCount: 0
}
